import { render, staticRenderFns } from "./SecurityPage.vue?vue&type=template&id=ccee274a"
import script from "./SecurityPage.vue?vue&type=script&lang=js"
export * from "./SecurityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports